<script lang="ts">
  import Hero from '../components/landing/Hero.svelte';
  import Features from '../components/landing/Features.svelte';
  import HowItWorks from '../components/landing/HowItWorks.svelte';
  import Comparison from '../components/landing/Comparison.svelte';
  import Screenshots from '../components/landing/Screenshots.svelte';
  import FAQ from '../components/landing/FAQ.svelte';
  import Philosophy from '../components/landing/Philosophy.svelte';
  import Support from '../components/landing/Support.svelte';
  import Footer from '../components/landing/Footer.svelte';
</script>

<main class="landing-page">
  <Hero />
  <Features />
  <HowItWorks />
  <Comparison />
  <Screenshots />
  <Philosophy />
  <FAQ />
  <Support />
  <Footer />
</main>

<style>
  .landing-page {
    min-height: 100vh;
    background: var(--color-background);
  }

  /* Add spacing between sections */
  .landing-page :global(section) {
    padding: var(--spacing-4xl) 0;
  }

  /* Remove extra padding from first section (Hero) */
  .landing-page :global(section:first-child) {
    padding-top: var(--spacing-3xl);
  }

  /* Alternate background colors for visual separation */
  .landing-page :global(section:nth-child(even):not(.footer)) {
    background: var(--color-background-secondary);
  }

  .landing-page :global(section:nth-child(odd):not(.footer)) {
    background: var(--color-background);
  }

  /* Footer keeps its dark background */
  .landing-page :global(.footer) {
    background: var(--color-text-primary) !important;
  }

  /* Mobile responsive spacing */
  @media (max-width: 768px) {
    .landing-page :global(section) {
      padding: var(--spacing-3xl) 0;
    }

    .landing-page :global(section:first-child) {
      padding-top: var(--spacing-2xl);
    }
  }
</style>
